import React from 'react'
import {
  Row, Col,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button
} from 'reactstrap'

import SignerCoordinatesConfigurationContainer from './container'

const defaultBodyHtml = () => {
  return (
    <Row>
      <Col md={12}>
        <p>
          Hemos detectado que el documento que estás subiendo contiene firmas digitales. Puedes indicar la ubicación de cada firma dentro del archivo.
        </p>
        <p>
          Si no defines una posición, la firma electrónica se insertará por defecto en la esquina inferior derecha.
        </p>
      </Col>
    </Row>
  )
}

const SignerCoordinatesConfigurationModal = props => {

  const {
    modal: {
      configuration: modalConfiguration = {},
      header: modalHeader = {},
      body: modalBody = {},
      footer: modalFooter = {},
    } = {},
    resource,
    callbacks: {
      setResource
    }
  } = props;

  const {
    isOpen = false,
    toggle = () => { },
    size = 'xl',
    unmountOnClose = true
  } = modalConfiguration;

  const {
    headerTitle = 'Posición de firmas',
  } = modalHeader;

  const {
    bodyHtml = defaultBodyHtml()
  } = modalBody;

  const {
    buttonActions = [
      {
        label: 'Listo',
        color: 'primary',
        onClick: toggle,
        size: 'md'
      }
    ]
  } = modalFooter;

  return (
    <Row>
      <Col md={12}>
        <Modal isOpen={isOpen} toggle={toggle} size={size} unmountOnClose={unmountOnClose}>
          <ModalHeader toggle={toggle}>{headerTitle}</ModalHeader>
          <ModalBody>
            {bodyHtml}
            <SignerCoordinatesConfigurationContainer
              resource={resource}
              callbacks={{
                setResource: setResource
              }}
            />
          </ModalBody>

          <ModalFooter>
            {buttonActions.map((button, index) => (
              <Button
                key={index}
                color={button.color}
                onClick={button.onClick}
                size={button.size}
                disabled={button.disabled}
              >
                {button.label}
              </Button>
            ))}
          </ModalFooter>
        </Modal>
      </Col>
    </Row>
  )
}

export default SignerCoordinatesConfigurationModal
